module.exports = __webpack_public_path__ + "static/media/m-kkaeda-dragon.3aa4d007.jpg";